import { FC } from "react";
import { ChevronDown as ChevronDownIconMain } from "lucide-react";
import { MEDIUM_ICON_SIZE_STYLES } from "../../ui/styles";

export const ChevronDownIcon: FC = () => {
  return (
    <ChevronDownIconMain
      className={`my-auto text-stone-400 ${MEDIUM_ICON_SIZE_STYLES}`}
    />
  );
};
